import { initAlertAPI } from '../module/alert/alert-slice.api';
import { initCatalogueAPI } from '../module/catalogue/catalogue-slice.api';
import { initChatAPI } from '../module/chat/chat-slice.api';
import { initCommentAPI } from '../module/comment/comment-slice.api';
import { initCustomerChatAPI } from '../module/customer-chat/customer-chat-slice.api';
import { initDocumentAPI } from '../module/document/document-slice.api';
import { initMainAPI } from '../module/main/main-slice.api';
import { initMessageAPI } from '../module/message/message-slice.api';
import { initMondayAPI } from '../module/monday/monday-slice.api';
import { initMonitoringAPI } from '../module/monitoring/monitoring-slice.api';
import { initNotificationAPI } from '../module/notification/notification-slice.api';
import { initProjectAPI } from '../module/project/project-slice.api';
import { initQuoteAPI } from '../module/quote/quote-slice.api';
import { initTaskAPI } from '../module/task/task-slice.api';
import { initUpsellAPI } from '../module/upsell/upsell-slice.api';
import { initUserAPI } from '../module/user/user-slice.api';
import { initFilesAPI } from '../module/files/files-slice.api';
import { initConfigurationAPI } from '../module/configuration/configuration-slice.api';

import { HttpChatGateway } from '../module/chat/http-chat.gateway';
import { HttpCustomerChatGateway } from '../module/customer-chat/http-customer-chat.gateway';
import { HttpCatalogueGateway } from '../module/catalogue/http-catalogue.gateway';
import { HttpAlertGateway } from '../module/alert/http-alert.gateway';
import { HttpCommentGateway } from '../module/comment/http-comment.gateway';
import { HttpDocumentGateway } from '../module/document/http-document.gateway';
import { HttpMainGateway } from '../module/main/http-main.gateway';
import { HttpMessageGateway } from '../module/message/http-message.gateway';
import { HttpMondayGateway } from '../module/monday/http-monday.gateway';
import { HttpMonitoringGateway } from '../module/monitoring/http-monitoring.gateway';
import { HttpNotificationGateway } from '../module/notification/http-notification.gateway';
import { HttpProjectGateway } from '../module/project/http-project.gateway';
import { HttpQuoteGateway } from '../module/quote/http-quote.gateway';
import { HttpTaskGateway } from '../module/task/http-task.gateway';
import { HttpUpsellGateway } from '../module/upsell/http-upsell.gateway';
import { HttpUserGateway } from '../module/user/http-user.gateway';
import { HttpFilesGateway } from '../module/files/http-files.gateway';
import { HttpConfigurationGateway } from '../module/configuration/http-configuration.gateway';
import { initCustomerDocumentAPI } from '../module/customer-document/customer-document-slice.api';
import { HttpCustomerDocumentGateway } from '../module/customer-document/http-customer-document.gateway';
import { initRibAPI } from '../module/rib/rib-slice.api';
import { HttpRibGateway } from '../module/rib/http-rib.gateway';

// import { InMemoryAlertGateway } from '../module/alert/inmemory-alert.gateway';

/**
 * TODODEV : faire accepter import.meta à Typescrip puis retirer les @ts-ignore ci-dessous
 */
export const useCrmConfiguration = (apiSlice: any) => {
  // @ts-ignore
  if (import.meta.env.VITE_ENVIRONNEMENT !== 'local') {
    initAlertAPI(apiSlice, new HttpAlertGateway());
    initCatalogueAPI(apiSlice, new HttpCatalogueGateway());
    initChatAPI(apiSlice, new HttpChatGateway());
    initCommentAPI(apiSlice, new HttpCommentGateway());
    initDocumentAPI(apiSlice, new HttpDocumentGateway());
    initMainAPI(apiSlice, new HttpMainGateway());
    initMessageAPI(apiSlice, new HttpMessageGateway());
    initMondayAPI(apiSlice, new HttpMondayGateway());
    initMonitoringAPI(apiSlice, new HttpMonitoringGateway());
    initNotificationAPI(apiSlice, new HttpNotificationGateway());
    initProjectAPI(apiSlice, new HttpProjectGateway());
    initQuoteAPI(apiSlice, new HttpQuoteGateway());
    initTaskAPI(apiSlice, new HttpTaskGateway());
    initUpsellAPI(apiSlice, new HttpUpsellGateway());
    initUserAPI(apiSlice, new HttpUserGateway());
    initFilesAPI(apiSlice, new HttpFilesGateway());
    initConfigurationAPI(apiSlice, new HttpConfigurationGateway());
    initRibAPI(apiSlice, new HttpRibGateway());

    // endpoint espace client mais à conserver pour la page CHAT,
    // TODODEV : séparer la logique de cette page pour les 2 applis, sous la forme de 2 composant Feature distinct
    // puis supprimer ces 2 endpoints
    initCustomerChatAPI(apiSlice, new HttpCustomerChatGateway());
    initCustomerDocumentAPI(apiSlice, new HttpCustomerDocumentGateway());
  } else {
    // initAlertAPI(apiSlice, new InMemoryAlertGateway());
  }
};
